// Default weather values
export const DEFAULT_WIND_SPEED = [0.0, 0.0, 0.0, 0.0];
export const DEFAULT_WIND_DIRECTION = [0, 0, 0, 0];
export const DEFAULT_FUEL_MOISTURE = [0, 0, 0, 0];
export const DEFAULT_TEMPERATURE = [0, 0, 0, 0];

// Map defaults
export const DEFAULT_MAP_STYLE = "mapbox://styles/mapbox/satellite-streets-v11";
export const DEFAULT_ZOOM = 10;
export const DEFAULT_PITCH = 0;

// Time defaults
export const DEFAULT_METEO_OPTION = "Réelles par satellite";
export const TIME_STEPS = [
  { label: "15 min", value: "15min" },
  { label: "30 min", value: "30min" },
 // { label: "45 min", value: "45min" },
  { label: "1 h", value: "1h" },
];
export const MAX_RESTRICTED_DEPARTMENTS = 5;
export const FR_MONTHS = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Décembre",
];
export const AREA_RANGES = [
  { value: "lt10", label: "< 10 ha", min: 0, max: 10 },
  { value: "10-100", label: "10 - 100 ha", min: 10, max: 100 },
  { value: "100-1000", label: "100 - 1000 ha", min: 100, max: 1000 },
  { value: "gt1000", label: "> 1000 ha", min: 1000, max: Infinity },
];